export default __webpack_public_path__ + "c60e4c78be2212c8610353b2121cf5c1.png";